// extracted by mini-css-extract-plugin
export var card = "PortfolioItem-module--card--AAGmo";
export var card__imageWrap = "PortfolioItem-module--card__imageWrap--ErpA2";
export var card__imageWrap__tags = "PortfolioItem-module--card__imageWrap__tags--vhy4v";
export var card__imageWrap__tags__text = "PortfolioItem-module--card__imageWrap__tags__text--BLQpx";
export var card__subtitle = "PortfolioItem-module--card__subtitle--YdVXV";
export var card__title = "PortfolioItem-module--card__title--i1gSe";